<button
  type="submit"
  class="btn btn-primary"
  [disabled]="isDisabled">
  {{ submitBtnTranslationKey ?? 'APPLICATION.FORM.save' | translate }}
</button>
